<template>
<div class="px-1 pt-1">
  <div class="input-group pb-3">
    <button class="btn btn-outline-secondary" @click="refresh()" :disabled="isLoading">
      <div v-if="isLoading" class="spinner-border spinner-border-sm"></div>
      <font-awesome-icon v-else :icon="['fas', 'rotate']" />
      <span class="d-none d-sm-inline">{{ $t('action.refresh') }}</span>
    </button>
    <button class="btn btn-outline-primary" @click="routeToCreateView()">
      <font-awesome-icon :icon="['fas', 'cart-shopping']" />
      {{ $t('action.newEllipsis') }}
    </button>
    <div class="form-check m-2">
      <input class="form-check-input" type="checkbox" v-model="showPast" id="showPast">
      <label class="form-check-label" for="showPast">{{ $t('action.showPast') }} <span class="text-nowrap">({{ $t('global.days', 10) }})</span></label>
    </div>
  </div>

  <ConsumptionList @selected="goToConsumption" :show-past="showPast" />
</div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { toast } from 'vue3-toastify';
import { useSessionStore, useItemsStore, useConsumptionsStore } from '@/stores';
import ConsumptionList from "@/components/consumptions/ConsumptionList.vue";
import { router } from "@/services";

const isLoading = ref(false);
const showPast = ref(false);

const sessionStore = useSessionStore();
const { selectedSiteId } = storeToRefs(sessionStore);

const itemsStore = useItemsStore();
const { data: items } = storeToRefs(itemsStore);

const consumptionsStore = useConsumptionsStore();

const goToConsumption = async (consumptionId: number) => {
  await router.push({ name: 'consumption', params: { consumptionId: consumptionId } });
}

const routeToCreateView = async () => {
  await router.push({ name: 'consumption-create' });
}

onMounted(async () => {
  await refresh();
  if (selectedSiteId.value === 0) {
    toast.error('No site selected', { autoClose: 10000 });
  }
  if (items.value.length === 0) {
    toast.error('No items available', { autoClose: 10000 });
  }
});

watch(showPast, async (newvalue) => {
  await consumptionsStore.fetchAll(newvalue);
});

async function refresh() {
  isLoading.value = true;
  try {
    await consumptionsStore.fetchAll();
  }
  finally {
    isLoading.value = false;
  }
}
</script>
